import { STEP_COUNT, STEP_LABELS } from '../merchantApplicationModel'

type Props = {
  currentStep: number
}

const StepProgress = ({ currentStep }: Props) => {
  const percent = ((currentStep + 1) / STEP_COUNT) * 100

  return (
    <div className="merchant-app-step-progress">
      <div className="merchant-app-progress-bar">
        <div
          className="merchant-app-progress-fill"
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className="merchant-app-step-label">
        Step {currentStep + 1} of {STEP_COUNT}: {STEP_LABELS[currentStep]}
      </div>
    </div>
  )
}

export default StepProgress
